import * as React from 'react';
import { extend, style } from 'typestyle';
import { vertical, center, startJustified } from 'csstips';
import { TrackTile } from '../track-tile';
import { percent, px, viewWidth } from 'csx';
import { colorBrand } from '../../theme/color';
import { mediaTablet, mediaMobileOnly } from '../../theme/media';
import { Carousel } from '../carousel';
import { TrackSchema } from '../../types/schema';
import { ImagePreloader } from '../../types/fn';
import { AnalyticsController } from '../../modules/analytics/controller';
import { Component, deps, inject, observer } from '../../lib/component';
import EmptyTile, { EmptyTileDimensionStyles } from './empty-tile';
import {
  constantTileCarouselAvailabilitySize,
  constantTileCarouselDesktopSize,
  constantTileCarouselMobileSize,
} from '../../theme/constant';
import { NestedCSSProperties } from 'typestyle/lib/types';

const commonTileContainerStyles: NestedCSSProperties = extend(
  {
    marginRight: px(16),
  },
  EmptyTileDimensionStyles,
);

export class PaddedCarousel extends React.Component<React.Component['props']> {
  render() {
    const { children } = this.props;

    const minLength = 5;

    const paddedTiles = Array.isArray(children) ? Array.from(children) : [children];
    if (paddedTiles.length < minLength) {
      for (let i = paddedTiles.length; i < minLength; i++) {
        paddedTiles.push(<EmptyTile className={PaddedCarousel.styles.emptyTileContainer} key={i} />);
      }
    }

    return (
      <Carousel
        className={PaddedCarousel.styles.carousel}
        innerClassName={PaddedCarousel.styles.carouselInner}
        spacerClassName={PaddedCarousel.styles.carouselSpacer}
      >
        {paddedTiles}
      </Carousel>
    );
  }

  static styles = {
    carousel: style(
      mediaMobileOnly({ height: `calc(${constantTileCarouselMobileSize} + ${constantTileCarouselAvailabilitySize})` }),
      mediaTablet({ height: `calc(${constantTileCarouselDesktopSize} + ${constantTileCarouselAvailabilitySize})` }),
    ),
    carouselInner: style(mediaMobileOnly({ padding: '0 20px' }), mediaTablet({ padding: '0 40px' })),
    carouselSpacer: style({ flexShrink: 0 }, mediaMobileOnly({ width: px(20) }), mediaTablet({ width: px(40) })),
    tileContainer: style(
      {
        ...vertical,
        ...center,
        ...startJustified,
        position: 'relative',
        height: 'auto !important',
        flexShrink: 0,
        flexBasis: 'auto',
        marginRight: px(16),
      },
      commonTileContainerStyles,
    ),
    emptyTileContainer: style(commonTileContainerStyles),
    tile: style({
      height: 'auto !important',
      width: percent(100),
    }),
    availability: style({
      height: constantTileCarouselAvailabilitySize,
      lineHeight: constantTileCarouselAvailabilitySize,
      fontWeight: 'bold',
      $nest: { '&> span': { color: colorBrand.toString() } },
    }),
  };
}
